import { render, staticRenderFns } from "./UserRequiredBuy.vue?vue&type=template&id=4e05a23a&scoped=true&"
import script from "./UserRequiredBuy.vue?vue&type=script&lang=js&"
export * from "./UserRequiredBuy.vue?vue&type=script&lang=js&"
import style0 from "./UserRequiredBuy.vue?vue&type=style&index=0&id=4e05a23a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e05a23a",
  null
  
)

export default component.exports